import Model from '@/store/model';
import MyResults from '@/store/models/user/my_results';
import Level from '@/store/models/user/level.js';
class Classmates extends Model {
    map(json) {
        super.map(json);

        if (json.my_result !== undefined && json.my_result !== null) {
            this.myResult = new MyResults();
            this.myResult.map(json.my_result);
        }

        if (json.level !== undefined && json.level !== null) {
            this.level = new Level();
            this.level.map(json.level);
        }

        // if (json.state !== undefined && json.state !== null) {
        //     this.state = new State();
        //     this.state.map(json.state);
        // }
    }
}
export default Classmates;